import React from 'react';
import Card from "../card/Card";
import history from "../../history";
import Label from "../label/Label";
import './ReportCard.css';
const ReportCard = (props) => {
	return (<Card className="g-report-card"
			tabIndex="0"
			onClick={() => {
				history.navigate(props.url);
			}}
		>
			<Label blue large>
				{props.title}
			</Label>
			<Label medium-small black>
				{props.description}
			</Label>
			<Label gray-medium medium-small />
		</Card>
	);
};

export default ReportCard;


// WEBPACK FOOTER //
// ./src/components/reportCard/ReportCard.jsx